import axios from "axios";
import {useEffect, useRef, useState} from "react";
import {useParams} from 'react-router-dom';
import Swal from 'sweetalert2';
import AutoComplete from '@mui/material/Autocomplete';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
function EditPacksurgery() {
    const {surgery_id} = useParams();
    const [packcats, setpackcats] = useState([]);
    const [insur, setInsur] = useState([]);
    const [items, setItems] = useState([]);
    const inputRefs = useRef([]);
    const [rows, setRows] = useState([]);
    const [subdata, setsubData] = useState([]);
    const [surgeryData, setsurgeryData] = useState({
        "pack": '',
        "insur": '',
        "surgery": '',
        "surgery_test": '',
        "surgeryamount": '',
        "status": '',
        "addedby": '',
        "ip_add": ''
    });
    useEffect(() => {
        const fetchData = async () => {
            try {
                const [surgeryResponse] = await Promise.all([
                    axios.get(`${baseUrl}surgery-type-create/`),
                ]);
                setItems(surgeryResponse.data);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, []);
    const handleChange = (event) => {
        setsurgeryData({
            ...surgeryData,
            [event.target.name]: event.target.value
        });
    }
    const handleKeyDown = (e, index) => {
        const newRows = [...rows];
        switch (e.keyCode) {
            // Handle Shift key
            case 16:
                e.preventDefault();
                if (index === rows.length - 1) {
                    newRows.push({id: '', type: '', amount: ''});
                }
                break;
            case 90:
                e.preventDefault();
                newRows.splice(index, 1);
                break;
            // Handle arrow up key
            case 38:
                e.preventDefault();
                if (newRows[index].selectedItem === 0) {
                    newRows[index].selectedItem = items.length - 1;
                } else {
                    newRows[index].selectedItem--;
                }
                setRows(newRows);
                break;
            // Handle arrow down key
            case 40:
                e.preventDefault();
                if (newRows[index].selectedItem === items.length - 1) {
                    newRows[index].selectedItem = 0;
                } else {
                    newRows[index].selectedItem++;
                }
                setRows(newRows);
                break;
            default:
                break;
        }
        setRows(newRows);
    };
    const handleSelect = (value, index) => {
        // Check if value is undefined or null
        if (value === undefined || value === null) {
            // Handle the scenario where the value is cleared or backspaced
            const newRows = [...rows];
            newRows[index] = {id: '', type: '', amount: ''};
            setRows(newRows);
        } else {
            // Handle the selection
            const selectedItem = items.find(item => item.type === value);
            if (selectedItem) {
                const newRows = [...rows];
                newRows[index] = {
                    id: selectedItem.id,
                    type: selectedItem.type,
                    amount: selectedItem.amount
                };
                setRows(newRows);
            }
        }
    };
    const handleAmountChange = (e, index) => {
        const newRows = [...rows];
        newRows[index].amount = parseFloat(e.target.value) || 0;
        setRows(newRows);
    };
    const handleAddRow = () => {
        const newRows = [...rows, {id: '', type: '', amount: ''}];
        setRows(newRows);
    };
    useEffect(() => {
        inputRefs.current[inputRefs.current.length - 1]?.focus();
    }, [rows]);
    const handleDeleteRow = (index) => {
        const newRows = [...rows];
        newRows.splice(index, 1);
        setRows(newRows);
        inputRefs.current.splice(index, 1);
    };
    useEffect(() => {
        try {
            axios.get(baseUrl + 'create-pack/')
                .then(function (response) {
                    setpackcats(response.data);
                });
        } catch (error) {
            console.log(error);
        }
        try {
            axios.get(`${baseUrl}insur-cmpy/`)
                .then(response => {
                    setInsur(response.data);
                })
        } catch (error) {
            console.log(error);
        }
    }, []);
    useEffect(() => {
        try {
            axios.get(baseUrl + 'edit-pack-surgery/' + surgery_id)
                .then(function (response) {
                    setsurgeryData({
                        insur: response.data.insur.id,
                        pack: response.data.pack.id,
                        surgery: response.data.surgery,
                        surgery_test: response.data.surgery_test,
                        surgeryamount: response.data.surgeryamount,
                    });
                });
        } catch (error) {
            console.log(error);
        }
    }, []);
    const formSubmit = () => {
        const _formData = new FormData();
        _formData.append('pack', surgeryData.pack);
        _formData.append('insur', surgeryData.insur);
        _formData.append('surgery', rows.map(row => row.id).join(','));
        _formData.append('surgery_test', rows.map(row => row.type).join(','));
        _formData.append('surgeryamount', rows.map(row => row.amount).join(','));
        _formData.append('status', '1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);
        try {
            axios.put(baseUrl + 'edit-pack-surgery/' + surgery_id, _formData, {
                headers: {
                    'content-type': 'multiple/form-data'
                }
            })
                .then(function (response) {
                    if (response.status == 200) {
                        Swal.fire({
                            title: 'Data has been updated',
                            icon: 'success',
                            timer: 2000,
                            showConfirmButton: false
                        });
                    }
                    setTimeout(() => {
                        window.location.href = ('/pack-surgery');
                    }, 2000);
                });
        } catch (error) {
            console.log(error);
        }
    };
    const surgeryIds = surgeryData.surgery ? surgeryData.surgery.split(',') : [];
    const surgeryAmounts = surgeryData.surgeryamount ? surgeryData.surgeryamount.split(',') : [];
    const fetchsurgeryData = async () => {
        try {
            const requests = surgeryIds.map(id => axios.get(`${baseUrl}edit-surgery-type/${id}`));
            const responses = await Promise.all(requests);
            const surgeryDataArray = responses.map(response => response.data);
            setRows(surgeryDataArray);
        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {
        fetchsurgeryData();
    }, [surgeryData]);
    return (
        <section className="container mt-4">
            <div className="row">
                <div className='col-md-9 col-12 mb-2'>
                    <div className='card'>
                        <h4 className='card-header'>Edit surgery Package</h4>
                        <div className='card-body'>
                            <form>
                                <div className="mb-3">
                                    <label htmlFor="pack" className="form-label">Package SubCategory</label>
                                    <select name="pack" value={surgeryData.pack} onChange={handleChange}
                                            className="form-control">
                                        <option>Choose Package SubCategory</option>
                                        {packcats.map((category, index) => {
                                            return <option key={index} value={category.id}>{category.packsubcat}
                                            </option>
                                        })}
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="insur" className="form-label">Insurance</label>
                                    <select name="insur" value={surgeryData.insur} onChange={handleChange}
                                            className="form-control">
                                        <option>Choose Insurance</option>
                                        {insur.map((insurer, index) => {
                                            return <option key={index} value={insurer.id}>
                                                {insurer.company}
                                            </option>
                                        })}
                                    </select>
                                </div>

                                <div className="table-responsive">
                                    <table className="erp-table-modern">
                                        <thead>
                                        <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Total</th>
                                            <th>Action</th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        {rows.map((entry, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <input
                                                        type="text"
                                                        className="ms-2 me-5 mt-4"
                                                        style={{width: 80}}
                                                        name="ltest_id"
                                                        value={entry.id}
                                                        onChange={(e) => handleChange(e, index, 'id')}
                                                        readOnly
                                                    />
                                                </td>
                                                <td>
                                                    <AutoComplete
                                                        className="form-control mt-2"
                                                        options={items.map(item => item.type)} // Replace with the data fetched from the server
                                                        value={entry.type} // Set the value based on the surgery entry
                                                        onChange={(event, value) => handleSelect(value, index)}
                                                        onInputChange={(event, newInputValue) => {
                                                            setRows(prevRows => {
                                                                const updatedRows = [...prevRows];
                                                                // Check if the row at the current index exists
                                                                if (updatedRows[index]) {
                                                                    updatedRows[index].type = newInputValue;
                                                                } else {
                                                                    // If the row doesn't exist, log an error or handle the case appropriately
                                                                    console.error(`Row at index ${index} is undefined.`);
                                                                }
                                                                return updatedRows;
                                                            });
                                                        }}
                                                        onKeyDown={e => handleKeyDown(e, index)}
                                                        renderInput={(params) => (
                                                            <div ref={params.InputProps.ref}>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    {...params.inputProps}
                                                                    focused autoFocus
                                                                    fullWidth
                                                                    style={{
                                                                        width: 300,
                                                                        background: "#F7EEFF",
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                        ref={(el) => inputRefs.current[index] = el}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="ms-2 me-5"
                                                        value={entry.amount}
                                                        name="amount"
                                                        style={{width: 100}}
                                                        onChange={handleChange}
                                                        onChange={(e) => handleAmountChange(e, index)}

                                                    />
                                                </td>
                                                <td>
                                                    <button className="btn btn-danger" type="button"
                                                            onClick={() => handleDeleteRow(index)}>Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}

                                        </tbody>
                                    </table>
                                    <button className="btn btn-success addmore mt-4" type="button"
                                            onClick={handleAddRow}>Add More
                                    </button>
                                </div>
                                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    <button type="button" onClick={formSubmit} className="btn btn-primary">Submit
                                    </button>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default EditPacksurgery;